<template>
  <div class="pp-picker" :style="{ '--pp-color': companyColor }">
    <h3 class="pp-panel-title">Escolha um modelo</h3>
    <p class="pp-panel-subtitle">Seus dados continuam os mesmos. Só muda o visual.</p>

    <div class="pp-picker__grid">
      <button
        v-for="template in templates"
        :key="template.id"
        type="button"
        class="pp-picker__item"
        :class="{ 'pp-picker__item--active': value === template.id }"
        @click="$emit('input', template.id)"
      >
        <div class="pp-picker__thumb">
          <template-thumb :template="template.id" />
          <pro-badge v-if="isProTemplate(template.id) && !isPro" class="pp-picker__pro" />
          <span v-if="value === template.id" class="pp-picker__check">
            <check-icon size="14" />
          </span>
        </div>
        <strong>{{ template.name }}</strong>
        <small>{{ template.short }}</small>
      </button>
    </div>

    <div v-if="selectedIsPro && !isPro" class="pp-pro-notice">
      <zap-icon size="18" />
      <p>
        O {{ selectedName }} é PRO. Dá para testar à vontade; para publicar com ele,
        <button type="button" @click="onSubscribe">assine</button>.
      </p>
    </div>
  </div>
</template>

<script>
import { CheckIcon, ZapIcon } from "vue-feather-icons";
import TemplateThumb from "./TemplateThumb.vue";
import ProBadge from "./ProBadge.vue";
import mixin from "./mixin";
import { TEMPLATES, templateById } from "./constants";

export default {
  name: "TemplatePicker",
  components: { TemplateThumb, ProBadge, CheckIcon, ZapIcon },
  mixins: [mixin],
  props: {
    value: { type: String, default: "classic" },
    proTemplates: { type: Array, default: () => [] },
    isPro: { type: Boolean, default: false },
  },
  computed: {
    templates() {
      return TEMPLATES;
    },
    selectedIsPro() {
      return this.isProTemplate(this.value);
    },
    selectedName() {
      return templateById(this.value).name;
    },
  },
  methods: {
    isProTemplate(id) {
      return this.proTemplates.includes(id);
    },
    onSubscribe() {
      this.ppTrack("public_profile_pro_cta_clicked", { cta: "template_notice", template: this.value });
      this.$emit("paywall");
    },
  },
};
</script>

<style lang="scss">
.pp-picker {
  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 8px;
    margin-top: 20px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 0;
    border: none;
    background: none;
    font-family: Roboto, sans-serif;
    text-align: left;
    cursor: pointer;

    strong {
      margin-top: 6px;
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }

    small {
      color: #696969;
      font-size: 12px;
      line-height: 1.3;
    }

    &:hover .pp-picker__thumb {
      border-color: #696969;
    }

    &--active .pp-picker__thumb,
    &--active:hover .pp-picker__thumb {
      border-color: var(--pp-color);
      box-shadow: 0 0 0 1px var(--pp-color);
    }
  }

  &__thumb {
    position: relative;
    overflow: hidden;
    border: 0.5px solid #a8a8a8;
    border-radius: 8px;
    transition: border-color 0.2s ease;
  }

  &__pro {
    position: absolute;
    top: 8px;
    left: 8px;
  }

  &__check {
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 9999px;
    background: var(--pp-color);
    color: #fff;
  }
}

.pp-pro-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 20px;
  padding: 12px 16px;
  border: 0.5px solid #6554c0;
  border-radius: 8px;
  background: rgba(101, 84, 192, 0.08);
  color: #333;
  font-size: 14px;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
    color: #6554c0;
  }

  button {
    padding: 0;
    border: none;
    background: none;
    color: #6554c0;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
